import { Button } from "components/atoms/Button";
import posthog from "posthog-js";

interface ConstructionFooterProps {
    handleCancel: () => void;
    handleSave: () => void;
    saveButtonIsDisabled: boolean;
}

function ConstructionFooter({ handleCancel, handleSave, saveButtonIsDisabled }: ConstructionFooterProps) {
    return (
        <div className="construction-sidebar__footer">
            <Button
                type="primary"
                id="edit-construction-save-button"
                disabled={saveButtonIsDisabled}
                onClick={() => {
                    handleSave();
                    posthog.capture("Construction updated");
                }}
            >
                Save
            </Button>
            <Button type="link" id="edit-construction-cancel-button" onClick={handleCancel}>
                Cancel
            </Button>
        </div>
    );
}

export default ConstructionFooter;
